import type { ReactNode } from 'react';

/**
 * What a list shows when it has nothing in it. `lg` is for a page whose
 * whole content is that list; the default spans the grid it sits in.
 */
export function EmptyState({
  size,
  children,
}: {
  size?: 'lg';
  children: ReactNode;
}) {
  if (size === 'lg')
    return (
      <div className="empty-card-lg">
        <p className="empty-text">{children}</p>
      </div>
    );
  return <p className="empty-card">{children}</p>;
}
